import script from "./markdown-editor-section.vue?vue&type=script&lang=ts&setup=true"
export * from "./markdown-editor-section.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__